import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../Model/Common/common.service';

@Component({
  selector: 'app-salary-billing-ratecontract-formula',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './salary-billing-ratecontract-formula.component.html',
  styleUrl: './salary-billing-ratecontract-formula.component.scss'
})
export class SalaryBillingRatecontractFormulaComponent {
  @Input() Formulas: any = [];
  @Input() Formula = null as any;
  @Input() SalaryHeadCode = null as any;
  @Input() SalaryHeadNamee = null as any;
  @Input() Percentage = null as any;
  @Input() SelectType = null as any;

  ReturnFormula = null as any;
  MainFormulas = [] as any;


  constructor(
    private activeModal: NgbActiveModal,
    private common: CommonService,
  ) { }

  ngOnInit(): void {
    this.MainFormulas = this.Formulas;

    let isDisabled = false;
    if (this.SelectType == 1) {
      this.Formulas.forEach((element: any) => {
        if (this.common.ToLowerCase(element.SalaryHeadCode) == this.common.ToLowerCase(this.SalaryHeadCode)) {
          isDisabled = true;
        }
        element.isDisabled = isDisabled;
      });
    } else if (this.SelectType == 2 || this.SelectType == 3) {
      this.Formulas.filter((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == this.common.ToLowerCase(this.SalaryHeadCode))[0].isDisabled = true;
    }

    if (this.Formula != null && this.Formula != "") {
      this.Formula.split("+").forEach((element: any) => {
        if (!this.Formulas.findIndex((e: any) => e.SalaryHeadCode == element).isDisabled) {
          this.Formulas[this.Formulas.findIndex((e: any) => e.SalaryHeadCode == element)].IsCheck = true;
        }
      });
    }

    this.CalcReturnFormula();
  }

  async Check(event: any, i: number, IsAll = false) {
    if (IsAll) {
      const ischeck = (event.target as HTMLInputElement).checked;
      const checkboxes = document.getElementsByName('IsCheckAll') as NodeListOf<HTMLInputElement>;
      checkboxes.forEach(checkbox => {
        checkbox.checked = false;
      });
      (event.target as HTMLInputElement).checked = ischeck;

      try {
        this.Formulas.filter((e: any) => !e.isDisabled).forEach((e: any) => e.IsCheck = ischeck);
      } catch (e) {
        console.error('Error in ARCheck:', e);
      }
    } else {
      if (!this.Formulas[i].isDisabled) {
        this.Formulas[i].IsCheck = event.target.checked;
      }
    }
    this.CalcReturnFormula();
  }

  CalcReturnFormula() {
    this.ReturnFormula = null;
    this.MainFormulas.filter((e: any) => e.IsCheck).map((e: any) => e.SalaryHeadCode).forEach((element: any) => {
      if (this.ReturnFormula == null || this.ReturnFormula == "") {
        this.ReturnFormula = element;
      } else {
        this.ReturnFormula += "+" + element;
      }
    });
  }

  SearchInTable(event: any,) {
    if (event.target.value != null && event.target.value != "") {
      this.Formulas = this.MainFormulas.filter((e: any) => this.common.ToLowerCase(e.SalaryHeadCode).includes(this.common.ToLowerCase(event.target.value)) ||
        this.common.ToLowerCase(e.SalaryHeadName).includes(this.common.ToLowerCase(event.target.value)));
    } else {
      this.Formulas = this.MainFormulas;
    }
  }

  close() {
    this.activeModal.close(null);
  }

  Ok() {
    this.activeModal.close(this.ReturnFormula);
  }
}
